


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData } from "../../customHooks/customHooks";
import { DELETE_MESSAGE, GET_CHAT_HISTORY, GET_CHAT_USERS, SEND_MESSAGE, } from "../../api";


// -- Async Thunk to Get User Profile --
export const GetAllChatHistory = createAsyncThunk('getAllChatHistory', async (body, { rejectWithValue }) => {

    try {
        // await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_CHAT_HISTORY, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data: data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllChatHistorySlice = createSlice({
    name: 'Chat',
    initialState: {
        ChatHistory: [],
        Chat: [],
        loading: false,
        status: '',
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllChatHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllChatHistory.fulfilled, (state, action) => {

                state.status = action.payload?.status 
                state.ChatHistory = [...state?.ChatHistory, ...action.payload?.data] // ✅ Store fetched profile

                state.Chat = action.payload?.data // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllChatHistory.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    },
    reducers: {
        setRemoveHistory: (state) => {
            state.ChatHistory = [];
            state.Chat = [];
        },

        setAddNewMessage: (state, action) => {
            state.ChatHistory = [action.payload, ...state.ChatHistory];
        },

        setUpdateMessage: (state, action) => {
            const values = action.payload;
            const updatedValue = state.ChatHistory.map(chat => {
                if (chat.chatMessageID === values.chatMessageID) {
                    return {
                        ...chat,
                        attachmentPath: values.attachmentPath,
                        chatMessageID: values.chatMessageID,
                        isRead: values.isRead,
                        message: values.message,
                        readAt: values.readAt,
                        receiverUserID: values.receiverUserID,
                        senderUserID: values.senderUserID,
                        sentAt: values.sentAt,
                    };
                }
                return chat;
            });
            state.ChatHistory = updatedValue;
            state.Chat = updatedValue;
        },

        setRemoveChat: (state, action) => {
            const messageId = action.payload;
            state.ChatHistory = state.ChatHistory.filter(chat => chat.chatMessageID !== messageId);
            state.Chat = state.Chat.filter(chat => chat.chatMessageID !== messageId);
        }
    }
});

// deleteChat ----
export const DeleteChatMessage = createAsyncThunk('deleteChat', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_MESSAGE, { ChatMessageID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            // Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return { status: response?.status }
        } else {
            return { status: response?.status }
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Async Thunk to Get User Profile --
export const GetAllChatUsers = createAsyncThunk('getAllChatUsers', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_CHAT_USERS, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const SendMessage = createAsyncThunk('sendMessage', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(SEND_MESSAGE, body);

        if (!response) throw new Error("No response received");
        if (response.status === 200) {
            return { status: response.status }
        } else if (response.status === 401) {
            return { status: response.status }
        } else {
            return { status: response.status }
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllChatUserSlice = createSlice({
    name: 'Connecton',
    initialState: {
        ConnectonUser: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllChatUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllChatUsers.fulfilled, (state, action) => {
                state.ConnectonUser = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllChatUsers.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

const ChatUserDetailSlice = createSlice({
    name: 'chat user',
    initialState: "",
    reducers: {
        setChatUserDetail: (state, action) => {
            return action?.payload
            // return
        }
    }
})

export const { setRemoveHistory, setAddNewMessage, setUpdateMessage, setRemoveChat } = GetAllChatHistorySlice.actions;

export const { setChatUserDetail } = ChatUserDetailSlice.actions;

export {
    GetAllChatHistorySlice,
    GetAllChatUserSlice,
    ChatUserDetailSlice
}